<template>
    <div>
        <ul class="navbar-nav sidebar color-black accordion" :class="{ 'toggled' : sidebarToggled }" id="accordionSidebar">

            <!-- Sidebar - Brand -->
            <router-link class="sidebar-brand d-flex align-items-center justify-content-center" to="/patients">
                <div class="sidebar-brand-icon">
                    <img src="/assets/images/logo.svg" title="Logo" />
                </div>
                <div class="sidebar-brand-text mx-3">
                    <h2>{{$t('COMPREHENSIVE_GERIATRIC_ASSESSMENT')}}</h2>
                </div>
            </router-link>
            
            <hr class="sidebar-divider my-0">
            <slot v-if="!cgaStatus">
                <slot v-for="(menu, index) in menus"> 
                    <li class="nav-item" :key="index" v-if="menu.isToBeShown">
                        <router-link :to="menu.url" active-class="active" class="nav-link py-2 text-white cgi-category-item-container">
                            <span class="category-icon ml-0"><icon :icon="menu.icon"/></span> 
                            <span class="category-name">{{menu.text}}</span> 
                        </router-link>
                    </li>
                    <hr :key="index+150" class="sidebar-divider my-0">
                </slot>
            </slot>
            <slot v-if="cgaStatus">
                <slot v-for="(category, index) in categories">
                    <li class="nav-item" :key="category.id">
                        <categoryWithStatus :category='category'></categoryWithStatus>
                    </li>
                    <hr :key="index+250" class="sidebar-divider my-0">
                </slot>
            </slot>

            <div class="text-center d-none d-md-inline">
                <button @click="toggleSidebar" class="btn btn-secondary btn-circle border-0 p-0 btn-sidebar-toggle"><icon :icon="(sidebarToggled ? 'arrow-circle-right' : 'arrow-circle-left')" /></button>
            </div>
        </ul>
    </div>
</template>
<script>
import CategoryWithStatus from './CategoryWithStatus'
export default {
    components: {
        'categoryWithStatus': CategoryWithStatus,
    },
    data() {
        return {
            sidebarToggled: false,
        }
    },
    computed: {
        menus() {
            return [
                {
                    'text': this.$t('PATIENTS'),
                    'icon': 'users',
                    'url': '/patients',
                    'isToBeShown': this.$store.getters.isPatientsToBeShown,
                },
                {
                    'text': this.$t('MEMBERSHIP'),
                    'icon': 'money-check-alt',
                    'url': '/membership',
                    'isToBeShown': this.$store.getters.isMembershipToBeShown,
                },
            ]
        },
        cgaStatus() {
            return this.$store.getters.cgaStatus;
        },
        cgaPatientSheet: function () {
            return this.$store.getters.cgaPatientSheet;
        },
        updateStatus() {
            return this.$store.getters.updateStatus;
        },
        categoryId() {
            return this.$route.params.id;
        },
        categories() {
            try {
                let self = this;
                return this.$store.getters.categoriesWithSteps.filter(function (obj) {
                    return obj.languageId == self.$store.getters.selectedLanguage.id;
                });
            }
            catch {
                return [];
            }

        },
    },
    methods: {
        toggleSidebar: function () {
            this.sidebarToggled = !this.sidebarToggled;
        },
        loadAllCategories: function () {
            let self = this;
            this.$store.dispatch('loadCategoryWithSteps')
                .then(response => {

                })
                .catch(error => {
                    console.log(error);
                })
        },
        loadAllCategoryStatuses: function () {
            let self = this;
            this.$store.dispatch('loadCategoryStatuses')
                .then(response => {
                })
                .catch(error => {
                    console.log(error);
                })
        },

    },
    mounted: function () {
        this.loadAllCategories();
        if (this.cgaPatientSheet != null)// On mount if cgaPatientSheet is loaded
            this.loadAllCategoryStatuses();
    },
    watch: {
        cgaPatientSheet: function (val) { // When cgaPatientSheet loads
            if (val != null) {
                this.loadAllCategoryStatuses();
            }
        },
        updateStatus: function (val) {
            if (val === true) { // When new Patient Answers are saved
                this.loadAllCategoryStatuses();
                this.$store.dispatch("setUpdateStatus", false);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    #toggle-btn {
        background: transparent;
        padding: 0px;
        font-size: 30px;
        color: black;
    }
    #accordionSidebar {
        background-color: #F6F6F6;
        color: black !important;
        .toggled {
            .category-name {
                display: none;
            }
        }
        .category-name, .category-icon, .sidebar-brand-text {
           color: black;
        }
        .cgi-category-item-container {
            ::v-deep .category-name {
                color: black !important;
            }
            ::v-deep .category-icon {
                color: red !important;
            }
            ::v-deep .status-icon {
                position: absolute !important;
                top: 11px !important;
                right: 15px !important;
            }
        }
    }
    .cgi-category-item-container{
        color: white !important;
        &:hover,
        &:focus,
        &:active {
            background: #D9D9D9;
        }
    }
</style>